/** Neutral place image fallback — generic pin, never a brand name. */
export const PLACE_PLACEHOLDER =
  "data:image/svg+xml," +
  encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" width="96" height="96" viewBox="0 0 96 96">
      <rect width="96" height="96" rx="12" fill="#EBF1FF"/>
      <path d="M48 20c-11 0-20 9-20 20 0 14 20 36 20 36s20-22 20-36c0-11-9-20-20-20zm0 28a8 8 0 1 1 0-16 8 8 0 0 1 0 16z" fill="#4A8DFF"/>
      <text x="48" y="88" text-anchor="middle" font-size="10" fill="#525866" font-family="sans-serif">Place</text>
    </svg>`
  );

export default PLACE_PLACEHOLDER;
